import { jsxs as C, jsx as a } from "react/jsx-runtime";
import k, { useState as y, useRef as I } from "react";
import { R as p, I as F } from "../chunks/index.cff5baaf.js";
import { a as R, b as w, _ as S } from "../chunks/vendor_rango__tokens.38ee67b0.js";
import n, { css as s } from "styled-components";
const _ = n.label.withConfig({
  displayName: "ChipSelect",
  componentId: "sc-14lxkxc-0"
})(["cursor:pointer;display:inline-flex;height:var(--size-5x);padding:var(--spacing-none) var(--spacing-1_5x);justify-content:center;align-items:center;flex-shrink:0;border-radius:var(--border-radius-circular);border-style:solid;border-width:var(--default-border-width);border-color:var(--elements-border-color);box-sizing:border-box;transition-property:background-color,border-color,opacity;transition-timing-function:var(--curve-productive-exit);transition-duration:var(--duration-fast-01);&:hover{", " border-color:transparent;transition-timing-function:var(--curve-productive-entrance);}", " ", ""], R, (r) => r.$focus && s(["", " outline-offset:2px;"], w), (r) => r.selected && s(["background-color:var(--selected-bg-color);border-color:transparent;transition-timing-function:var(--curve-productive-entrance);&:hover{background-color:var(--selected-bg-color);opacity:var(--hover-container);}", "{color:var(--on-selected-icon-color);}", "{color:var(--on-selected-label-color);}"], d, f)), N = n.input.withConfig({
  displayName: "Input",
  componentId: "sc-14lxkxc-1"
})(["all:unset;"]), d = n(p).withConfig({
  displayName: "Icon",
  componentId: "sc-14lxkxc-2"
})(["padding-right:var(--spacing-half);"]), f = n.span.withConfig({
  displayName: "Label",
  componentId: "sc-14lxkxc-3"
})(["", " color:var(--text-label-color);"], S), z = k.forwardRef(({
  children: r,
  selected: c = !1,
  icon: t,
  inputProps: e,
  ...h
}, u) => {
  const [g, l] = y(!1), b = I(), v = (o) => {
    e != null && e.onChange && e.onChange(o);
  }, m = () => t ? /* @__PURE__ */ a(d, { icon: t, size: F.SM }) : null, x = (o) => {
    l(!0), e != null && e.onFocus && e.onFocus(o);
  }, i = (o) => {
    l(!1), e != null && e.onFocus && e.onFocus(o);
  };
  return /* @__PURE__ */ C(_, { selected: c, $focus: g, ref: u, "data-testid": "rango-chip-select", "data-rango-component": "rango-chip-select", "data-is-rango": !0, ...h, children: [
    /* @__PURE__ */ a(N, { ref: b, type: "checkbox", defaultChecked: c, checked: c, onChange: v, onFocus: x, onBlur: i, onClick: (o) => {
      o.clientX === 0 && o.clientY === 0 || i();
    }, ...e }),
    m(),
    /* @__PURE__ */ a(f, { children: r })
  ] });
});
z.displayName = "RangoChipSelect";
export {
  z as RangoChipSelect
};
